import axios from 'axios'

const state = {
  email: '',
  name: '',
  token: ''
}

const getters = {
  isAuthenticated: ( state ) => !!state.token
}

const actions = {
  async login( { commit }, user ) {
    const res = await axios.post( '/login', user );
    const email = user.get( 'email' );
    const token = res.data.result.token
      // console.log( token )
    await commit( 'setUser', { email, token } )
  },
  async check( context ) {
    let code = '';
    console.log( context.state.token )
    try {
      await axios.get( '/me', {
        headers: {
          Authorization: 'Bearer ' + context.state.token
        }
      } )
      code = 200;
    } catch ( error ) {
      code = error.response.status
    }

    await context.commit( 'CHECK_USER', code )
  }
}

const mutations = {
  setUser( state, { email, token } ) {
    state.email = email
    state.token = token
  },
  CHECK_USER( state, code ) {

    if ( code !== 200 ) {
      window.localStorage.clear( )
    }
    // console.log( state )
    // console.log( res )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}